import React from 'react'
import {Route, IndexRoute} from 'react-router'

import DataCollectionViewMenu from 'views/DataCollectionView/menu'
import DataColllectionView from 'views/DataCollectionView/'
import ImpressionView from 'views/DataCollectionView/ImpressionView'
import SourceMappingDataView from 'views/DataCollectionView/SourceMappingDataView'

import OnboardingWizard from 'components/OnboardingWizard'
import {StepTypes} from 'redux/modules/onboard/steps'

const withOnboardingWizard = (Component, currentStep) => {
  return props => (
    <>
      <OnboardingWizard currentStep={currentStep} />
      <Component {...props} />
    </>
  )
}

export default trackRoute => {
  return (
    <Route path='data-collection' title='Data Collection/Ingestion'>
      <Route
        path='impressions'
        title='Impressions'
        components={{
          main: withOnboardingWizard(ImpressionView, StepTypes.DATA_COLLECTION),
          menu: DataCollectionViewMenu
        }}
        onEnter={trackRoute('/data-collection/impressions')}
      />
      <Route
        path='source-mapping'
        title='Source Mapping Data'
        components={{
          main: withOnboardingWizard(
            SourceMappingDataView,
            StepTypes.DATA_COLLECTION
          ),
          menu: DataCollectionViewMenu
        }}
        onEnter={trackRoute('/data-collection/source-mapping')}
      />
      <IndexRoute
        title='Incomming Data'
        components={{
          main: withOnboardingWizard(
            DataColllectionView,
            StepTypes.DATA_COLLECTION
          ),
          menu: DataCollectionViewMenu
        }}
        onEnter={trackRoute('/data-collection')}
      />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/dataCollection.js